import { render, staticRenderFns } from "./DomainRoot.vue?vue&type=template&id=91d6bb24&scoped=true&"
import script from "./DomainRoot.vue?vue&type=script&lang=js&"
export * from "./DomainRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d6bb24",
  null
  
)

export default component.exports